/**
 * CheckELogo — Xpert brand mark.
 *
 * v2 design: green rounded square + white check inside. Single mark, no
 * separate "e" + check-badge layering anymore. The mark IS the check.
 * Sampled from the locked logo and provided by the v2 design handoff
 * (`/assets/logo-mark.svg`); inlined here so the navbar / footer / badges
 * / emails / OG images all render the same artifact without an HTTP fetch.
 *
 * The wordmark "Xpert" is now Fraunces 700 ink (was Inter + gold gradient).
 *
 * Props (API preserved — every existing call site keeps working)
 * --------------------------------------------------------------
 *   size            number   pixel size of the mark (default 38)
 *   withWordmark    bool     render "Xpert" next to the mark
 *   wordmarkColor   string   override (defaults to ink #0E1410)
 *   className       string   extra classes for the outer span
 */
export default function CheckELogo({
  size = 38,
  withWordmark = false,
  wordmarkColor,
  className = "",
}) {
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      style={{ lineHeight: 1 }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Xpert logo"
        role="img"
      >
        {/* Brand-green rounded square — the locked mark */}
        <rect x="2" y="2" width="60" height="60" rx="12" ry="12" fill="#17803D" />
        {/* White check — exact scale of the canonical CLAUDE.md spec.
            Spec is `M 5 12.5 L 10 17.5 L 19 7` in viewBox 24×24; this
            file uses viewBox 64×64 so all coordinates × (64/24 ≈ 2.667).
            Stroke-width 3 in vb-24 → 8 in vb-64. */}
        <path
          d="M 13.33 33.33 L 26.67 46.67 L 50.67 18.67"
          stroke="#FFFFFF"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {withWordmark && (
        <span
          style={{
            color: wordmarkColor || "#0E1410",                /* ink */
            /* v2 spec: Fraunces 700-800 wordmark, -0.02em tracking */
            fontFamily: "'Fraunces', Georgia, serif",
            fontWeight: 700,
            fontSize: Math.round(size * 0.62),
            letterSpacing: "-0.02em",
          }}
        >
          Xpert
        </span>
      )}
    </span>
  );
}
